module.exports = __webpack_public_path__ + "img/blue_074.edfffeb1.png";